import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminActivityReasonComponent } from "../admin-activity-reason/admin-activity-reason.component";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-activity-status",
  templateUrl: "./admin-activity-status.component.html",
  styleUrls: ["./admin-activity-status.component.css"],
})
export class AdminActivityStatusComponent implements OnInit {
  loading: boolean = false;
  statusActivity: any;
  token: any;
  matDialogref: MatDialogRef<AdminActivityReasonComponent>;

  constructor(
    private matdialogref: MatDialogRef<AdminActivityStatusComponent>,
    private services: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matDialog: MatDialog,
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
  }
  close() {
    this.matdialogref.close();
  }

  public getActivity() {
    this.services.activityGet(this.token).subscribe(
      (response: any) => { },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  approve() {
    this.loading = true;
    this.services
      .updateStatus(
        this.token,
        "available",
        "truckowner",
        this.data.loginInfo[0]?.ref_id
      )
      .subscribe(
        (response: any) => {
          this.loading = false;
          this.snackBar.open("Truck owner Approved", "Success", {
            duration: 5000,
          });
          this.matdialogref.close({ status: "success" });
        },
        (error) => {
          this.loading = false;
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  reject() {
    this.matDialogref = this.matDialog.open(AdminActivityReasonComponent, {
      width: "40vw",
      data: {
        id: this.data.loginInfo[0]?.ref_id,
        status: this.data,
        user_data: this.data.loginInfo[0]?.user_type,
        userStatus: "rejected",
      },
    });
    this.matDialogref.afterClosed().subscribe((x) => {
      if (x?.status == "success") {
        this.matdialogref.close({ status: "success" });
      }
    });
  }
}

